import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import BaseModal from '../types/Base';
import Button from '../../Button';
import {_openModal, _removeModal} from '../../../store';
import {parseErrorMessage} from '../../../utils/utils';
import DescriptiveText from '../../DescriptiveText';
import Row from '../../Row';

const AccountLocked = props => {
  const {err, button, title} = props.content;
  const {dispatchRemoveModal, openModal} = props;
  const executeAction = () => {
    if (button && button.action) {
      button.action(button.data);
    }
    dispatchRemoveModal();
  };

  return <BaseModal onClose={() => dispatchRemoveModal(props.content)} title={title}>
    <DescriptiveText>{parseErrorMessage(err)}</DescriptiveText>
    <Row wrap={true}>
      <a onClick={() => {
        dispatchRemoveModal(props.content);
        openModal({componentName: 'ForgotPassword'});
      }}>Forgot password</a>
    </Row>
    <Row wrap={true}>
      <Button
        importance={'primary'}
        size={'md'}
        label={(button && button.text) || 'OK'}
        disabled={false}
        action={executeAction}>
      </Button>
    </Row>
  </BaseModal>;
};

const mapDispatchToProps = dispatch => ({
  dispatchRemoveModal: modal => {
    dispatch(_removeModal(modal));
  },
  openModal: modal => {
    dispatch(_openModal(modal));
  },
});

export default connect(null, mapDispatchToProps)(AccountLocked);

AccountLocked.propTypes = {
  /**
   * Function that closes current modal popup
   */
  dispatchRemoveModal: PropTypes.func.isRequired,
  /**
   * Function that opens modals throughout page
   */
  openModal: PropTypes.func.isRequired,
  /**
   * The error details to display in the modal.
   */
  content: PropTypes.shape({
    title: PropTypes.string,
    err: PropTypes.shape({
      title: PropTypes.string,
      msg: PropTypes.string,
      response: PropTypes.shape({
        data: PropTypes.shape({
          error: PropTypes.shape({
            title: PropTypes.string,
            msg: PropTypes.string,
          }),
        }),
      }),
      message: PropTypes.string,
    }).isRequired,
    /**
     * If button needs to be customized, then pass the text, action, and data for button
     */
    button: PropTypes.shape({
      text: PropTypes.string,
      action: PropTypes.func,
      data: PropTypes.object,
    }),
  }).isRequired,
};

